import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import _ from 'lodash';
import { Table } from 'semantic-ui-react';

const commaFormat = num => numeral(num).format('0a');

const tableStyles = {
  border: 'none',
  'text-align': 'center',
  paddingTop: 5,
  paddingBottom: 5,
};

const tableHandleStyles = {
  border: 'none',
  'text-align': 'left',
  paddingTop: 5,
  paddingBottom: 5,
  paddingLeft: 5,
};

const iconStyle = {
  height: '24px',
  width: '24px',
};

const followerCountStyle = {
  margin: '5px',
};

const handleStyle = {
  margin: '5px',
};

const getYoutubeLink = influencer => {
  const { youtube, youtubeChannelId } = influencer;
  const derivedYoutube = youtubeChannelId || youtube;
  if (!derivedYoutube) return '';
  const channelIdRegex = /^UC([a-zA-Z0-9_-]{22})$/;
  return derivedYoutube.match(channelIdRegex) ? 'channel/' : 'user/';
};

const getLinkedItem = (influencer, channel) => {
  let handle = channel === 'youtube' ? _.get(influencer, 'youtubeChannelId') : influencer[channel];
  const youtubeShim = channel === 'youtube' ? getYoutubeLink(influencer) : '';
  const tiktokExtra = channel === 'tiktok' ? '@' : '';

  if (handle) {
    console.log(handle.length);
    const truncateText = (handle.length > 15 ? '...' : '');
    const handle15 = _.take(handle, 15);
    let displayHandle = _.concat(handle15, truncateText);

    if (channel === 'youtube') {
      const youtubeChannelTitle = _.get(influencer, 'youtubeChannelTitle');
      displayHandle = youtubeChannelTitle || handle;
    }

    return (
      <a
        href={`https://www.${channel}.com/${youtubeShim}${tiktokExtra}${handle}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img style={iconStyle} src={`/icons/${channel}.svg`} alt={channel} />
        <span style={handleStyle} className="light">{displayHandle}</span>
      </a>
    );
  }

  return (
    <div>
      <img style={iconStyle} src={`/icons/${channel}.svg`} alt={channel} />
      <span style={followerCountStyle} className="light">-</span>
    </div>
  );
};

const getFollowersCount = (influencer, channel) => (
  <span style={followerCountStyle} className="light">{commaFormat(influencer[`${channel}Count`]) || '-'}</span>
);

const getTiktokER = influencer => {
  const tikTokER = _.get(influencer, 'tiktokProfileData.engagementData.engagementRate');
  return tikTokER ? `${tikTokER}%` : '-';
};

const SocialTable = ({ influencer, selectedPlatforms }) => {
  const {
    instagram,
    facebook,
    youtube,
    twitter,
    twitch,
    tiktok,
  } = selectedPlatforms || {};

  const showAll = !selectedPlatforms;

  return (
    <Table basic="very" singleLine>
      <Table.Body>
        <Table.Row>
          <Table.Cell style={tableStyles} width={8}>
            Channel
          </Table.Cell>
          <Table.Cell style={tableStyles} width={5}>
            Followers
          </Table.Cell>
          <Table.Cell style={tableStyles} width={3}>
            E.R.
          </Table.Cell>
        </Table.Row>
        { (instagram || showAll) && <Table.Row>
          <Table.Cell style={tableHandleStyles}>
            { getLinkedItem(influencer, 'instagram') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            { getFollowersCount(influencer, 'instagram') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            { _.get(influencer, 'instagramEngagementRate', '-') }
            { _.get(influencer, 'instagramEngagementRate') ? '%' : '' }
          </Table.Cell>
        </Table.Row> }
        { (facebook || showAll) && <Table.Row>
          <Table.Cell style={tableHandleStyles}>
            { getLinkedItem(influencer, 'facebook') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            { getFollowersCount(influencer, 'facebook') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            -
          </Table.Cell>
        </Table.Row> }
        { (youtube || showAll) && <Table.Row>
          <Table.Cell style={tableHandleStyles}>
            { getLinkedItem(influencer, 'youtube') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            { getFollowersCount(influencer, 'youtube') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            -
          </Table.Cell>
        </Table.Row> }
        { (tiktok || showAll) && <Table.Row>
          <Table.Cell style={tableHandleStyles}>
            { getLinkedItem(influencer, 'tiktok') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            { getFollowersCount(influencer, 'tiktok') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            { getTiktokER(influencer) }
          </Table.Cell>
        </Table.Row> }
        { (twitch || showAll) && <Table.Row>
          <Table.Cell style={tableHandleStyles}>
            { getLinkedItem(influencer, 'twitch') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            { getFollowersCount(influencer, 'twitch') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            -
          </Table.Cell>
        </Table.Row> }
        { (twitter || showAll) && <Table.Row>
          <Table.Cell style={tableHandleStyles}>
            { getLinkedItem(influencer, 'twitter') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            { getFollowersCount(influencer, 'twitter') }
          </Table.Cell>
          <Table.Cell style={tableStyles}>
            -
          </Table.Cell>
        </Table.Row> }
      </Table.Body>
    </Table>
  );
};

SocialTable.propTypes = {
  influencer: PropTypes.object.isRequired,
  selectedPlatforms: PropTypes.object,
};

export default SocialTable;



// WEBPACK FOOTER //
// ./src/components/social-table/index.js